<script setup lang="ts">
import { storeToRefs } from 'pinia';
import MenuList from '@layout/nav-v2/desktop/components/MenuList.vue';
import { trans, transchoice } from '@elements/translation.ts';
import { getDistrict } from '@elements/address-utils.ts';
import LocationSubmenuItem from '@layout/nav-v2/LocationSubmenuItem.vue';
import LocationHeaderLink from '@layout/nav-v2/LocationHeaderLink.vue';
import { slugify } from '@tools/stringFormatter.ts';
import Divider from '@components/Divider.vue';
import { useNavbarStore } from '@stores/layout/useNavbarStore';

const {
  parisAreaUrl,
  parisDistricts,
  parisPois,
  idfAreaUrl,
  idfCities,
  franceAreaUrl,
  franceCities,
} = storeToRefs(useNavbarStore());
</script>

<template>
  <MenuList
    :class="[
      'px-4',
      'flex flex-col gap-y-4'
    ]"
  >
    <li>
      <LocationHeaderLink
        :link="parisAreaUrl"
        class="w-full h-14"
      >
        {{ trans('user_menu.top.locations.paris.title') }}
      </LocationHeaderLink>

      <MenuList class="grid grid-cols-4">
        <li
          v-for="parisDistrict in parisDistricts"
          :key="parisDistrict"
        >
          <LocationSubmenuItem
            class="h-11 justify-center"
            :link="`location-bureau-paris-${parisDistrict}`"
          >
            {{ transchoice('user_menu.top.locations.paris.district', { district: getDistrict(parisDistrict) }) }}
          </LocationSubmenuItem>
        </li>
      </MenuList>

      <Divider class="my-3" color="gray" />

      <MenuList>
        <li
          v-for="parisPoi in parisPois"
          :key="parisPoi"
        >
          <LocationSubmenuItem
            :link="`location-bureau-${slugify(parisPoi)}`"
            class="h-11"
          >
            {{ parisPoi }}
          </LocationSubmenuItem>
        </li>
      </MenuList>
    </li>

    <li>
      <Divider class="m-0" color="gray" />
    </li>

    <li>
      <LocationHeaderLink
        :link="idfAreaUrl"
        class="w-full h-14"
      >
        {{ trans('user_menu.top.locations.ile_de_france.title') }}
      </LocationHeaderLink>

      <MenuList>
        <li
          v-for="idfCity in idfCities"
          :key="idfCity"
        >
          <LocationSubmenuItem
            :link="`location-bureau-${slugify(idfCity)}`"
            class="h-11"
          >
            {{ idfCity }}
          </LocationSubmenuItem>
        </li>
      </MenuList>
    </li>

    <li>
      <Divider class="m-0" color="gray" />
    </li>

    <li>
      <LocationHeaderLink
        :link="franceAreaUrl"
        class="w-full h-14"
      >
        {{ trans('user_menu.top.locations.france.title') }}
      </LocationHeaderLink>

      <MenuList class="grid grid-cols-2">
        <li
          v-for="franceCity in franceCities"
          :key="franceCity"
        >
          <LocationSubmenuItem
            :link="`location-bureau-${slugify(franceCity)}`"
            class="h-11"
          >
            {{ franceCity }}
          </LocationSubmenuItem>
        </li>
      </MenuList>
    </li>
  </MenuList>
</template>
